import { __awaiter, __generator } from "tslib";
import { Fetch } from '@ekuaibao/fetch';
import { app as api } from '@ekuaibao/whispered';
import { session } from '@ekuaibao/session-info';
import { getCorpId } from '../lib/lib-util';
import { isEmptyObject } from '@ekuaibao/helpers';
import { enableLoginLimitLogoutAfterClose } from '../lib/featbit/feat-switch';
import { getBoolVariation } from '../lib/featbit';
export default systemLimitLogout;
var LOGIN_LIMIT_LAST_ACTIVE_TIME_KEY = 'loginLimitLastActiveTime';
export function shouldEnableLoginLimit(safeSetting) {
    return !!safeSetting && !isEmptyObject(safeSetting) && (safeSetting === null || safeSetting === void 0 ? void 0 : safeSetting.limitTimeId) !== 'neverOut';
}
export function getLoginLimitTimeout(safeSetting) {
    var timeOut = 60 * 1000;
    var _a = safeSetting || {}, limitTimeId = _a.limitTimeId, selfTime = _a.selfTime;
    switch (limitTimeId) {
        case 'fiveMin':
            return timeOut * 5;
        case 'twentyMin':
            return timeOut * 20;
        case 'sixtyMin':
            return timeOut * 60;
        case 'selfTime':
            return timeOut * selfTime;
        default:
            return timeOut;
    }
}
export function getLoginLimitLastActiveTime(storageValue, now) {
    var lastActiveTime = Number(storageValue);
    return Number.isFinite(lastActiveTime) && lastActiveTime > 0 ? lastActiveTime : now;
}
export function isLoginLimitExpired(lastActiveTime, now, timeOut) {
    return now - lastActiveTime > timeOut;
}
export function systemLimitLogout() {
    return __awaiter(this, void 0, void 0, function () {
        var params, corporations, e_1, safeSetting, storageKey, nowTime, timeOut, enableLogoutAfterClose, lastTime, currentTime, timeType, webDomId, updateLastActiveTime, clusterLogout, logout, limitTime;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = { sensitiveWords: true };
                    if (window.__PLANTFORM__ === 'MC')
                        params.corpId = getCorpId();
                    corporations = null;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4, api.dataLoader('@common.safeSettingV3').load()];
                case 2:
                    corporations = _a.sent();
                    return [3, 5];
                case 3:
                    e_1 = _a.sent();
                    console.error('---------系统退出时间限制corporations error', e_1);
                    return [4, Fetch.GET('/api/v1/organization/corporations/info', params).then(function (res) { return res.value; })];
                case 4:
                    corporations = _a.sent();
                    return [3, 5];
                case 5:
                    console.log('---------系统退出时间限制corporations', corporations);
                    safeSetting = corporations === null || corporations === void 0 ? void 0 : corporations.safeSetting;
                    if (!shouldEnableLoginLimit(safeSetting)) {
                        return [2];
                    }
                    storageKey = LOGIN_LIMIT_LAST_ACTIVE_TIME_KEY + ":" + (getCorpId() || 'default');
                    nowTime = new Date().getTime();
                    timeOut = getLoginLimitTimeout(safeSetting);
                    enableLogoutAfterClose = enableLoginLimitLogoutAfterClose();
                    lastTime = enableLogoutAfterClose
                        ? getLoginLimitLastActiveTime(localStorage.getItem(storageKey), nowTime)
                        : nowTime;
                    currentTime = new Date().getTime();
                    timeType = false;
                    webDomId = document.getElementById('web');
                    updateLastActiveTime = function () {
                        lastTime = new Date().getTime();
                        if (enableLogoutAfterClose) {
                            localStorage.setItem(storageKey, String(lastTime));
                        }
                    };
                    clusterLogout = function () { return __awaiter(_this, void 0, void 0, function () {
                        var corpId, existGP, logoutUrl, paramsStr;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    corpId = getCorpId();
                                    existGP = corpId === null || corpId === void 0 ? void 0 : corpId.includes('~GP');
                                    logoutUrl = (_a = window.PLATFORMINFO) === null || _a === void 0 ? void 0 : _a.logoutUrl;
                                    logoutUrl = logoutUrl && existGP ? logoutUrl : '';
                                    paramsStr = corpId ? "fromCluster=true&corpId=" + corpId : '';
                                    sessionStorage.setItem('isLogOutUrl', 'true');
                                    return [4, Fetch.DELETE('/api/account/v2/session')];
                                case 1:
                                    _b.sent();
                                    location.href = logoutUrl + "/web/app.html?" + paramsStr + "#/login";
                                    return [2];
                            }
                        });
                    }); };
                    logout = function () { return __awaiter(_this, void 0, void 0, function () {
                        var cloudAuthUrl, _a;
                        var _b, _c, _d, _e;
                        return __generator(this, function (_f) {
                            switch (_f.label) {
                                case 0:
                                    if (enableLogoutAfterClose) {
                                        localStorage.removeItem(storageKey);
                                    }
                                    if (!(((_b = window.PLATFORMINFO) === null || _b === void 0 ? void 0 : _b.clusterURL) && window.__PLANTFORM__ !== 'MC')) return [3, 1];
                                    clusterLogout();
                                    return [3, 10];
                                case 1:
                                    if (!window.IS_SMG) return [3, 3];
                                    sessionStorage.setItem('isLogOutUrl', 'true');
                                    return [4, Fetch.DELETE('/api/account/v2/session')];
                                case 2:
                                    _f.sent();
                                    location.href = (_c = window.PLATFORMINFO) === null || _c === void 0 ? void 0 : _c.logoutUrl;
                                    return [3, 10];
                                case 3:
                                    session.clear();
                                    Fetch.DELETE('/api/account/v2/session');
                                    (_e = (_d = api.sdk) === null || _d === void 0 ? void 0 : _d.logout) === null || _e === void 0 ? void 0 : _e.call(_d);
                                    localStorage.removeItem('enableCloudAuth');
                                    cloudAuthUrl = window.PLATFORMINFO.cloudAuthUrl;
                                    if (!(cloudAuthUrl && getBoolVariation('FKXM-14', false))) return [3, 9];
                                    _f.label = 4;
                                case 4:
                                    _f.trys.push([4, 6, 7, 8]);
                                    return [4, window.fetch(cloudAuthUrl + "/cloud-auth/public/auth/logout", {
                                            method: 'POST',
                                            credentials: 'include',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'cloud-auth-token': localStorage.getItem('cloudAuthToken') || undefined
                                            }
                                        })];
                                case 5:
                                    _f.sent();
                                    return [3, 8];
                                case 6:
                                    _a = _f.sent();
                                    return [3, 8];
                                case 7:
                                    location.replace(cloudAuthUrl + "/web/login");
                                    return [7];
                                case 8: return [3, 10];
                                case 9:
                                    api.go('/login', true);
                                    _f.label = 10;
                                case 10: return [2];
                            }
                        });
                    }); };
                    if (enableLogoutAfterClose &&
                        isLoginLimitExpired(lastTime, nowTime, timeOut) &&
                        window.location.href.indexOf('login') < 0) {
                        logout();
                        return [2];
                    }
                    updateLastActiveTime();
                    webDomId && webDomId.addEventListener('mousemove', updateLastActiveTime);
                    limitTime = function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            timeType = window.location.href.indexOf('login') < 0;
                            currentTime = new Date().getTime();
                            console.log('---------系统退出时间限制lastTime+currentTime+timeType+timeOut', lastTime, currentTime, timeType, timeOut, currentTime - lastTime);
                            if (currentTime - lastTime > timeOut) {
                                if (timeType) {
                                    logout();
                                    lastTime = new Date().getTime();
                                }
                                else {
                                    updateLastActiveTime();
                                }
                            }
                            return [2];
                        });
                    }); };
                    window.setInterval(limitTime, 5000);
                    return [2];
            }
        });
    });
}
